import { render, staticRenderFns } from "./WriteCreate.vue?vue&type=template&id=6df5ff68&scoped=true"
import script from "./WriteCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./WriteCreate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WriteCreate.vue?vue&type=style&index=0&id=6df5ff68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5ff68",
  null
  
)

export default component.exports